// extracted by mini-css-extract-plugin
export default {"block":"index_block_vO6iV","title":"index_title_JTl3m","list":"index_list_fpKah","item":"index_item_cIR4W"};